import { type SocialMediaType } from '@prisma/client';
import { getMentionUrl } from '~/components/ScannedPage/Caption';

export const sanitizeUsername = (username: string, type: SocialMediaType) => {
  if (username.startsWith('https://')) {
    const mentionUrl = getMentionUrl(type).replace('www.', '');

    return username.replace('www.', '').split(mentionUrl)[1]?.split(/[?/]/)[0] ?? '';
  }

  return username;
};
